import { render, staticRenderFns } from "./UpdateRoom.vue?vue&type=template&id=a55bdb2a&scoped=true&"
import script from "./UpdateRoom.vue?vue&type=script&lang=js&"
export * from "./UpdateRoom.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRoom.vue?vue&type=style&index=0&id=a55bdb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55bdb2a",
  null
  
)

export default component.exports